// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"2ebda136","160":"e85746c3","312":"3dbd60f7","718":"87972170"}[chunkId] + ".chunk.css";
};